import { useMemo } from 'react';
import DeviceControl from '~/components/DeviceControl/DeviceControl';
import PulseControl from '~/components/PulseControl/PulseControl';
import RegisterControl from '~/components/RegisterControl/RegisterControl';
import { useHelpRef } from '~/systems/help';
import { useUiState } from '~/systems/uiState';
import './ExperimentSpecsControl.css';

export default function ExperimentSpecsControl() {
  const uiState = useUiState();
  const helpRef = useHelpRef<HTMLDivElement>('controls');

  const deviceControlOpen =
    uiState.focusedPanel == null ||
    uiState.focusedPanel === 'Histogram' ||
    uiState.focusedPanel === 'Code' ||
    uiState.focusedPanel === 'QuantumState';

  const registerControlOpen = uiState.focusedPanel === 'Register';
  const pulseControlOpen = uiState.focusedPanel === 'Channels';

  const pulseSelectionKey = useMemo(
    () => Array.from(uiState.pulseSelection).join(','),
    [uiState.pulseSelection]
  );

  return (
    <div
      ref={helpRef}
      className="ExperimentSpecsControl-controls u-scrollbarDark"
    >
      <DeviceControl
        key={`device-${deviceControlOpen}`}
        initialState={deviceControlOpen}
      />
      <RegisterControl
        key={`register-${registerControlOpen}`}
        initialState={registerControlOpen}
      />
      <PulseControl
        key={`${pulseSelectionKey}-${pulseControlOpen}`}
        initialState={pulseControlOpen}
      />
    </div>
  );
}
